import { createApiConstants } from '@saucelabs/sl-util-redux';

export const createTrendsTypes = (namespace) => {
  const createApiNamespacedConstants = createApiConstants.bind(null, namespace);

  return {
    GET_TEST_TRENDS: createApiNamespacedConstants('GET_TEST_TRENDS'),
    GET_TEST_ERRORS: createApiNamespacedConstants('GET_TEST_ERRORS'),
    GET_BUILDS_TESTS: createApiNamespacedConstants('GET_BUILDS_TESTS'),
    GET_TESTS: createApiNamespacedConstants('GET_TESTS'),
    GET_TESTS_BY_BUILD: createApiNamespacedConstants('GET_TESTS_BY_BUILD'),
    SET_CURRENT_PAGE: `${namespace}/SET_CURRENT_PAGE`,
    SET_STATUS_FILTER: `${namespace}/SET_STATUS_FILTER`,
    SET_TESTS_BY_BUILD: `${namespace}/SET_TESTS_BY_BUILD`,
    CLEAN_UP: `${namespace}/CLEAN_UP`,
  };
};
